import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router'
import {IntegrationNs} from '@shared/types'
import {useIntegrationStore} from "@domains/settings/stores/integration.store";
import {getLocalStorage, removeItemLocalStorage} from "@shared/helpers";
import {toast} from '@shared/ms-components'

export const confirmFigmaAuthenticationResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {
    const payload = {
        authCode: to.query.code,
        state: to.query.state,
        integrationType: IntegrationNs.IntegrationTypeEnums.FIGMA
    } as IntegrationNs.ConfirmAuthenticationRequest

    const intStore = useIntegrationStore();
    const figmaCallback = getLocalStorage('figmaCallback') as any;
    intStore.confirmAuthentication(payload).then(() => {
        toast.success('Authentication successful');

        if (figmaCallback) {
            next({path: figmaCallback.path, query: {figmaSidebar: 'open'}})
            removeItemLocalStorage('figmaCallback');
        } else {
            next({path: '/settings/integrations/figma'})
        }
    }).catch(() => {
        toast.error('Authentication unsuccessful')

        if (figmaCallback) {
            next({path: figmaCallback.path, query: {figmaSidebar: 'open'}})
            removeItemLocalStorage('figmaCallback');
        } else {
            next({path: '/settings/integrations'})
        }
    })
}
